(() => {
  const bar = document.querySelector('[data-fg-info-bar]');
  if (!bar) return;

  const close = bar.querySelector('[data-fg-info-close]');
  const identity = bar.dataset.infoKey || 'announcement';
  const storageKey = `58g-info-bar-${identity}`;
  const inEditor = Boolean(window.Shopify && window.Shopify.designMode);

  if (inEditor) {
    document.documentElement.classList.remove('fg-info-bar-dismissed');
  } else {
    try {
      if (window.localStorage.getItem(storageKey) === 'dismissed') {
        document.documentElement.classList.add('fg-info-bar-dismissed');
        bar.hidden = true;
        return;
      }
    } catch (error) {}
    document.documentElement.classList.remove('fg-info-bar-dismissed');
  }

  if (!close) return;
  close.addEventListener('click', () => {
    bar.hidden = true;
    if (!inEditor) {
      try { window.localStorage.setItem(storageKey, 'dismissed'); } catch (error) {}
    }
  });
})();
